import cn from 'clsx';

import aemClientService from '@/services/aem/aemClientService';
import type {IconModel} from '@/types/aem';

interface RemoteIconProps {
    icon?: IconModel;
    className?: string;
}

const RemoteIcon = ({icon, className}: RemoteIconProps) => {
    const src = aemClientService.getAssetPath(icon?.path);

    if (!src) return null;

    return <img src={src} alt={icon?.alt ?? ''} aria-hidden={!icon?.alt} className={cn('object-contain', className)} />;
};

export default RemoteIcon;
